import {
  Building2,
  Briefcase,
  Landmark,
  CreditCard,
  Laptop,
  Globe,
  Rocket,
} from "lucide-react";

export const SERVICES = [
  {
    id: "startup-funding",
    title: "Startup Funding",
    short: "Seed · Angel · VC · Debt · Govt Grants",
    description:
      "End-to-end startup funding services for Indian founders — pre-seed and seed funding, angel investment, venture capital, Series A, venture debt, bridge funding and government grants. ZOZO Venture's fundraising consultants drive investor matchmaking, pitch deck creation, startup valuation, term sheet review and due diligence — from your first investor meeting to the first cheque.",
    bullets: [
      "Pitch deck, financials & startup valuation",
      "Angel investors, VC firms & venture debt matchmaking",
      "Startup India + DPIIT recognition & Seed Fund Scheme",
      "SIDBI Fund of Funds, MSME / Mudra / CGTMSE loans",
      "Term sheet review, cap table & due diligence support",
    ],
    Icon: Rocket,
  },
  {
    id: "company-registration",
    title: "Company Registration",
    optionLabel: "Company Registration — Pvt Ltd / LLP / (OPC) Pvt. Ltd.",
    short: "Pvt Ltd · LLP · OPC · Resident + NRI",
    description:
      "Private Limited Company Registration in India is our hero offering — MCA name approval, SPICe+ filing, DIN, DSC, MOA / AOA, PAN and TAN in one integrated flow, typically live in 7–10 working days. Also LLP and OPC / other entity types. Built for founders based in India and for NRIs registering remotely with apostilled documents and FEMA / RBI compliance handled.",
    bullets: [
      "Private Limited Company Registration — SPICe+, DIN, DSC, PAN, TAN (7–10 days)",
      "LLP Registration — FiLLiP filing + LLP Agreement drafting",
      "OPC, Partnership Firm & Sole Proprietorship",
      "Company Name Availability check on MCA + trademark",
      "NRI remote registration + FEMA / RBI / FC-GPR compliance",
    ],
    Icon: Building2,
  },
  {
    id: "office-space",
    title: "Office Space",
    short: "Co-working · Virtual · Registered Address",
    description:
      "Find the right workspace — hot desks, private cabins, virtual offices and compliant registered addresses.",
    bullets: ["Pan-India network", "Flexible contracts", "Registered address"],
    Icon: Briefcase,
  },
  {
    id: "banking",
    title: "Business Banking",
    short: "HDFC · ICICI · KOTAK",
    description:
      "Fast-track current account opening with trusted banking partners — priority RMs and zero paper chase.",
    bullets: ["Relationship manager", "2–5 day onboarding", "Zero-balance options"],
    Icon: Landmark,
  },
  {
    id: "payments",
    title: "Payment Gateways",
    short: "Razorpay · Cashfree · PhonePe",
    description:
      "Accept payments online within days. We help you pick, onboard and go live with the right PG for your business.",
    bullets: ["Lowest MDR negotiation", "KYC + Go-live in days", "UPI / cards / wallets"],
    Icon: CreditCard,
  },
  {
    id: "it-hardware",
    title: "IT Infrastructure Solutions",
    short: "Laptops · Desktops · Servers",
    description:
      "Procure business-grade laptops, desktops, servers, peripherals and networking gear at the best bulk pricing.",
    bullets: ["OEM partnerships", "GST invoicing & warranty", "Pan-India delivery"],
    Icon: Laptop,
  },
  {
    id: "digital-presence",
    title: "Digital Presence",
    short: "Website · SEO · Social · Ads",
    description:
      "Launch your website, grow organically with SEO, and scale with performance ads across Google & Meta.",
    bullets: ["Website in 2 weeks", "SEO + Paid Ads", "Social media management"],
    Icon: Globe,
  },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.optionLabel || s.title);
export const DEFAULT_SERVICE_OPTION = "Company Registration — Pvt Ltd / LLP / (OPC) Pvt. Ltd.";
